const timers = {};

const timerCheckerStart = {
  ws_new_connection: [
    () => createTimerChecker('ws_new_connection_t1', 'ws_new_connection_timeout_', 1000),
    () => createTimerChecker('ws_new_connection_t2', 'ws_new_connection_timeout_', 1500),
    () => createTimerChecker('ws_new_connection_t3', 'ws_new_connection_timeout_', 2000),
  ],
  chat_login: [
    () => createTimerChecker('chat_login_t1', 'chat_login_timeout_', 1000),
    () => createTimerChecker('chat_login_t2', 'chat_login_timeout_', 1500),
    () => createTimerChecker('chat_login_t3', 'chat_login_timeout_', 2000),
  ],
  chat_get_history: [
    () => createTimerChecker('chat_get_users_t1', 'chat_get_users_timeout_', 1000),
    () => createTimerChecker('chat_get_users_t2', 'chat_get_users_timeout_', 1500),
    () => createTimerChecker('chat_get_users_t3', 'chat_get_users_timeout_', 2000),
  ],
};

const timerCheckerFinish = {
  ws_connected: ['ws_new_connection_t1', 'ws_new_connection_t2', 'ws_new_connection_t3'],
  ws_disconnected: ['ws_new_connection_t1', 'ws_new_connection_t2', 'ws_new_connection_t3'],
  chat_login_success: ['chat_login_t1', 'chat_login_t2', 'chat_login_t3'],
  chat_login_error: ['chat_login_t1', 'chat_login_t2', 'chat_login_t3'],
  chat_get_users_success: ['chat_get_users_t1', 'chat_get_users_t2', 'chat_get_users_t3'],
};


class GrayLog {
  constructor() {
    this.user = null;
    this.session = Math.random().toString(36).substring(2, 15);
    this.sequence = 1; // log messages sequence number
    this.enabled = false;
    this.url = '';
  }
  init(enabled, url) {
    this.enabled = enabled;
    this.url = url;
  }
  getSession() {
    return this.session;
  }
  setUser(user) {
    this.user = user;
  }
  log(message, options) {
    this._sendData('log', message, options);
  }
  warning(message, options) {
    this._sendData('warning', message, options);
  }
  _sendData(type, message, options) {
    if (!this.enabled) return;

    const url = this.url + 'log/' + type + '/' + message;

    const data = {
      full_message: message,
      _session: this.session,
      _sequence: this.sequence++,
      _user_id: this.user ? this.user.id : null,
      //_mobile: config.isMobile,
      _url: location.href,
    };

    if (options && 'ws_connection_time' in options) {
      data._ws_connection_time = options.ws_connection_time;
    }

    const params = {
      method: 'POST',
      headers: {
        'Content-type': 'application/json; charset=UTF-8'
      },
      body: JSON.stringify(data),
    };

    console.log('gray_log', message, data);

    // stop timers if event finished
    if (timerCheckerFinish[message]) {
      timerCheckerFinish[message].forEach(timerKey => {
        clearTimeout(timers[timerKey])
      })
    }

    // start timers to check for event not ready in long time
    if (timerCheckerStart[message]) {
      timerCheckerStart[message].forEach(timerFunc => {
        timerFunc();
      });
    }

    fetch(url, params);
  }
}


const grayLog = new GrayLog();
//grayLog.setUser(config.user);

export default grayLog;


function createTimerChecker(timerName, message, timeout) {
  if (timers[timerName]) {
    clearTimeout(timers[timerName]);
  }

  timers[timerName] = setTimeout(() => {
    grayLog.warning(message + timeout)
  }, timeout);
}
